import auth from '../auth';

const helper = {
  async get(vm, url, query) {
    try {
      let qs = query;
      const hash = auth.isLoggedIn();
      if (hash) {
        qs = Object.assign(
          query || {},
          {
            sessionHash: hash,
          },
        );
      }
      const response = await vm.$http.get(url, { params: qs });
      return response.body;
    } catch (err) {
      err.failed = true;
      return err;
    }
  },
  async post(vm, url, data, isMultipart) {
    try {
      const hash = auth.isLoggedIn();
      let headers = {};
      if (hash) {
        if (isMultipart) {
          headers = {
            'Content-Type': 'multipart/form-data',
          };
          data.append('sessionHash', hash);
        } else {
          Object.assign(
            data || {},
            {
              sessionHash: hash,
            },
          );
        }
      }
      const response = await vm.$http.post(
        url,
        data,
        headers,
      );
      return response.body;
    } catch (err) {
      err.failed = true;
      return err;
    }
  },
  async put(vm, url, data, isMultipart) {
    try {
      const hash = auth.isLoggedIn();
      let headers = {};
      if (hash) {
        if (isMultipart) {
          headers = {
            'Content-Type': 'multipart/form-data',
          };
          data.append('sessionHash', hash);
        } else {
          Object.assign(
            data || {},
            {
              sessionHash: hash,
            },
          );
        }
      }
      const response = await vm.$http.put(
        url,
        data,
        headers,
      );
      return response.body;
    } catch (err) {
      err.failed = true;
      return err;
    }
  },
  async delete(vm, url, data) {
    try {
      const hash = auth.isLoggedIn();
      if (hash) {
        Object.assign(
          data || {},
          {
            sessionHash: hash,
          },
        );
      }
      const response = await vm.$http.delete(url, { params: data });
      return response.body;
    } catch (err) {
      err.failed = true;
      return err;
    }
  },
};

export default helper;



// WEBPACK FOOTER //
// ./src/helpers/web.js